<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app dark>
      <v-list-item>
        <v-list-item-content>
          <div class="text-center">
            <img src="@/assets/HearRo_white_shield.svg"/>
          </div>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list>
        <!-- <v-list-item link :to="{name: 'activity'}">
          <v-list-item-content>
            <v-list-item-title>Activity</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
        <v-list-item link :to="{name: 'conversations'}">
          <v-list-item-content>
            <v-list-item-title>Conversations</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="{name: 'connections'}">
          <v-list-item-content>
            <v-list-item-title>Connections</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- <v-list-item link :to="{name: 'credentials'}">
          <v-list-item-content>
            <v-list-item-title>Credentials</v-list-item-title>
          </v-list-item-content>
        </v-list-item> -->
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app flat color="secondary" dark outlined>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>{{ routeName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-avatar color="accent" size="40" v-if="avatarImage()">
        <v-img :src="`https://api.adorable.io/avatars/93/${loggedInUser.user.email}`"></v-img>
      </v-avatar>
      <v-avatar color="accent" size="40" v-else>
        {{ avatarLetters() }}
      </v-avatar>
      <span class="pl-2">{{ loggedInUser.user.email }}</span>
      <v-menu
        left
        bottom>
      <template v-slot:activator="{ on }">
          <v-btn icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="logout">Log Out</v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content>
      <v-slide-x-transition leave-absolute>
        <router-view />
      </v-slide-x-transition>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    source: String
  },

  data: () => ({
    drawer: null
  }),

  methods: {
    ...mapActions({
      logout: 'hearro/logout'
    }),
    avatarImage () {
      if (!this.loggedInUser.user || !this.loggedInUser.user.image) {
        return false
      }
      return this.loggedInUser.user.image.find(e => e.type === 'avatar').location || false
    },
    avatarLetters () {
      if (!this.loggedInUser.user.name) {
        return ''
      }
      let initials = ''
      if (this.loggedInUser.user.name.first) {
        initials = this.loggedInUser.user.name.first.substring(0, 1)
      }
      if (this.loggedInUser.user.name.last) {
        initials = initials.concat('', this.loggedInUser.user.name.last.substring(0, 1))
      }

      return initials
    }
  },

  computed: {
    ...mapGetters('hearro', ['loggedInUser']),
    routeName () {
      // console.log("route", this.$route)
      return this.$route.name.charAt(0).toUpperCase() + this.$route.name.slice(1)
    }
  },

  mounted () {
    console.log(this.$vuetify.theme.themes);
  }
};
</script>
